import { compose as e } from "../../tailwind-buddy-interface.js";
const s = e({
  slots: {
    root: ""
  },
  variants: {},
  defaultVariants: {},
  compoundVariants: [
    {
      conditions: {
        isMonochrome: !1
      },
      class: (
        /** @tw */
        `
        text-color-scheme-interactive-link-600
        hover:text-color-scheme-interactive-link-500
        active:text-color-scheme-interactive-link-600
      `
      )
    },
    {
      conditions: {
        disableUnderline: !0
      },
      class: (
        /** @tw */
        "hover:underline"
      )
    },
    {
      conditions: {
        disableUnderline: !1
      },
      class: (
        /** @tw */
        "underline"
      )
    },
    {
      conditions: {
        disableVisitedStyles: !1,
        isMonochrome: !1
      },
      class: (
        /** @tw */
        "visited:text-color-scheme-literal-purple-600"
      )
    }
  ]
})();
export {
  s as linkVariants
};
